import { useService } from "./service.js";
import keyCodes from "../utils/keyCodes.js";
function getInitialKeyCodes() {
  return Object.fromEntries(Object.keys(keyCodes).map((key2) => [key2, false]));
}
function createKeyService() {
  let previousEvent;
  function updateProps(event) {
    props.event = event;
    Object.entries(keyCodes).forEach(([name, code]) => {
      props[name] = code === event.keyCode;
    });
    if (!previousEvent) {
      props.triggered = 0;
    }
    if (props.event.type === "keydown" && (previousEvent == null ? void 0 : previousEvent.type) === "keydown") {
      props.triggered += 1;
    } else {
      props.triggered = 1;
    }
    previousEvent = props.event;
    props.direction = props.event.type === "keydown" ? "down" : "up";
    props.isUp = props.event.type === "keyup";
    props.isDown = props.event.type === "keydown";
    return props;
  }
  function onKey(event) {
    trigger(updateProps(event));
  }
  const { add, remove, has, trigger, props } = useService({
    props: {
      event: null,
      triggered: 0,
      isUp: false,
      isDown: false,
      direction: "none",
      ...getInitialKeyCodes()
    },
    init() {
      document.addEventListener("keydown", onKey);
      document.addEventListener("keyup", onKey);
    },
    kill() {
      document.removeEventListener("keydown", onKey);
      document.removeEventListener("keyup", onKey);
    }
  });
  return {
    add,
    remove,
    has,
    props: () => props
  };
}
let key;
function useKey() {
  if (!key) {
    key = createKeyService();
  }
  return key;
}
export {
  useKey as default
};
